module.exports = __webpack_public_path__ + "static/190215-POS-Algemene-Voorwaarden-v1.0-163577990be855c96c01d78a6ebbe07e.pdf";